/**
 * @generated SignedSource<<135a027cb7e1e2bacefa59ccf69d1190>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RequestResetPasswordInput = {
  email: string;
  userService?: boolean | null;
  clientMutationId?: string | null;
};
export type requestResetPasswordMutation$variables = {
  input: RequestResetPasswordInput;
};
export type requestResetPasswordMutation$data = {
  readonly requestResetPassword: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly success: boolean | null;
  } | null;
};
export type requestResetPasswordMutation = {
  variables: requestResetPasswordMutation$variables;
  response: requestResetPasswordMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestResetPasswordPayload",
    "kind": "LinkedField",
    "name": "requestResetPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestResetPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestResetPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4039ea6aaa01fd0799a7e93991b20e9d",
    "id": null,
    "metadata": {},
    "name": "requestResetPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation requestResetPasswordMutation(\n  $input: RequestResetPasswordInput!\n) {\n  requestResetPassword(input: $input) {\n    errors\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a8e63ad0db47147c7b45abda3983bff";

export default node;
